import { render } from "./HelpDialogWorkflowAi.vue?vue&type=template&id=2f030572"
import script from "./HelpDialogWorkflowAi.vue?vue&type=script&lang=js"
export * from "./HelpDialogWorkflowAi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__